import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
// import axios from 'axios';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';
import { checkDomain } from './Classes/checkDomain';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class LoginGuard implements CanActivate {

  constructor(public authService: AuthService, public router: Router, private http: HttpClient) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

      const token = localStorage.getItem('access_token');
      // axios.defaults.withCredentials = true;
      // axios
      //   .get(environment.HTTP+environment.API_URL+'/api/domain', { params: { domain: checkDomain() } })
      //   .then((resp) => {

      //     if (resp.data.result.verified === true) {
      //       // window.history.back();
      //       const newUrl = `${environment.HTTP}${environment.CLIENT_URL}`;
      //       window.location.href = newUrl;
      //     }
      //   }).catch((err) => {
          
      //   });

      const params = new HttpParams().set('domain', checkDomain());
      
      this.http.get<any>( `${environment.HTTP}${environment.API_URL}/api/domain`, { params, withCredentials: true }).subscribe({
        next: (resp) => {
          // console.log(resp);
          if (resp?.result?.verified === true) {
            const newUrl = `${environment.HTTP}${environment.CLIENT_URL}`;
            window.location.href = newUrl;
          }
        },
        error: (err) => {
          console.error(err);
        }
      });

      this.http.get<any>( environment.HTTP+ checkDomain() + '.'+environment.API_URL+'/api/ping', { headers: {"Authorization" : `Bearer ${token}`} }).subscribe({
        next: (resp) => {
          if (resp?.result === true && this.authService.isLoggedIn === true) {
            this.router.navigate(['/management'], { replaceUrl: true });
          }
        },
        error: (err) => {
          console.error(err);
        }
      });

      // axios
      //   .get(environment.HTTP+ checkDomain() + '.'+environment.API_URL+'/api/ping', { headers: {"Authorization" : `Bearer ${token}`} })
      //   .then((resp) => {
      //     if (resp.data.result === true && this.authService.isLoggedIn === true) {
      //       return this.router.navigate(['/management'], { replaceUrl: true });    
      //     }
      //     return true;

      //   }).catch((err) => {

      //   });
      
      return true;

  }
  
}
